<template>
  <div v-if="ready">
    <h2>{{ $t('views.checkout.payment.payment') }}</h2>
    <br>
    <div align="center">
      <div id='app' v-if="!paymentAccepted">
        <card class='stripe-card'
          v-if="stripePublicKey"
          :class='{ complete }'
          :stripe='stripePublicKey'
          :options='stripeOptions'
          @change='complete = $event.complete'
          @focus="saveAddressToCart()"
          ref="stripeCard"
          style="color:#fff;"
        />
        <br>
        <br>
        <br>
        <v-row>
          <v-col align="center">
            <p>{{ $t('views.checkout.payment.payment_confirm_info_text') }} <router-link :to="{ name: 'page', params: { slug: 'terms-and-conditions' }}">{{ $t('views.checkout.payment.terms_confirm_link_text') }}</router-link> </p>
          </v-col>
        </v-row>

        <v-btn color="success" :outlined="!checkoutFormCompleted" elevation="0" class="ma-2 white--text" @click="createPaymentMethod()" :loading="processingPayment" :disabled="!checkoutFormCompleted">
          {{ $t('views.checkout.payment.payment_confirm_btn') }}
          <v-icon right dark>mdi-truck-fast-outline</v-icon>
        </v-btn>
      </div>


      <div v-if="paymentAttemptCompleted">
        {{paymentAttemptMessage}}
      </div>

      <div align="center">
        <!-- <ul style="list-style-type: none;">
          <li v-if="!shippingMethodAdded" class="error--text">Please select a shipping method</li>
          <li v-if="shippingMethodAdded" class="success--text">Shipping method added</li>

          <li v-if="!billingAddressAdded" class="error--text">Please provide a billing address</li>
          <li v-if="billingAddressAdded" class="success--text">Billing address added</li>


          <li v-if="!shippingAddressAdded" class="error--text">Please provide a shipping address</li>
          <li v-if="shippingAddressAdded" class="success--text">Shipping address added</li>

          <li v-if="!paymentDetailsAdded" class="error--text">Please provide payment details</li>
          <li v-if="paymentDetailsAdded" class="success--text">Payment details added</li>

          <li v-if="!paymentMethodAdded" class="error--text">Please select a payment method</li>
          <li v-if="paymentMethodAdded" class="success--text">Payment method added</li>


        </ul> -->

      </div>

    </div>

  </div>
</template>

<script>
// import { stripeKey, stripeOptions } from './stripeConfig.json'
import { CardNumber, CardExpiry, CardCvc, Card, createPaymentMethod, confirmCardPayment, instance } from 'vue-stripe-elements-plus'
// import {loadStripe} from '@stripe/stripe-js';
import PaymentService from "@/services/PaymentService.js"
import CartService from "@/services/CartService.js"
import SaveAddressRequest from "@/packages/Address/src/Models/RequestModels/SaveAddressRequest.js"

export default {
  name: 'payment',
  components: {
    Card,
    CardNumber,
    CardExpiry,
    CardCvc
  },
  data () {
    return {
      ready: false,
      complete: false,
      stripePublicKey: null,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
        style: {
          base: {
            iconColor: '#666ee8',
            color: '#31325f',
            fontWeight: 400,
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '15px',
            '::placeholder': {
              color: '#aab7c4',
            },
            ':-webkit-autofill': {
              color: '#666ee8',
            },
          },
          invalid: {
            iconColor: '#FFC7EE',
            color: '#FFC7EE',
          },
        },
      },
      paymentIntent: null,
      processingPayment: false,
      paymentAttemptCompleted:false,
      paymentAttemptMessage: null,
      paymentAccepted: false,
    }
  },
  computed: {
    checkoutFormCompleted: function () {

      if (this.shippingMethodAdded && this.shippingMethodAdded && this.billingAddressAdded && this.shippingAddressAdded && this.paymentMethodAdded && this.paymentDetailsAdded) {
        return true;
      }
      return false;
    },
    shippingMethodAdded: function () {
      if (this.cart) {
        if (this.cart.selected_shipping_rate) {
          if(this.cart.selected_shipping_rate.method) {
            return true;
          }
        }
      }
      return false;
    },
    billingAddressAdded: function () {
      if (this.cart) {
        if (this.cart.billing_address) {
          if(this.cart.billing_address.city) {
            return true;
          }
        }
      }
      return false;
    },
    shippingAddressAdded: function () {
      if (this.cart) {
        if (this.cart.shipping_address) {
          if(this.cart.shipping_address.city || this.cart.billing_address.use_for_shipping == true) {
            return true;
          }
        }
      }
      return false;

    },
    paymentMethodAdded: function () {
      if (this.cart) {
        if (this.cart.payment) {
          if(this.cart.payment.method) {
            return true;
          }
        }
      }
      return false;
    },
    paymentDetailsAdded: function () {
      if(this.complete) {
        return true;
      }
      return false;
    },

    cart: function () {
      return this.$store.state.checkout.cart;
    },
  },
  async mounted() {
    await this.setStripePublicKey();
    await this.mountStripeScript();

    let component = this;

    setTimeout(function () {
      component.ready = true; // We must ensure that the Stripe script is loaded and parsed, before the component renders!
    }, 1000);

  },
  methods: {
    saveAddressToCart() {
      // Create an instance of SaveAddressRequest()
      let saveAddressRequestPayload = new SaveAddressRequest(this.$store.state.checkout.billingAddress.address, this.$store.state.checkout.shippingAddress.address);
      CartService.saveAddressToCart(saveAddressRequestPayload)
      .then(response => {
        // console.log(response);
      }).catch(error => {
        console.log(error);
      })
    },
    setStripePublicKey() {
      this.stripePublicKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY;
    },
    createPaymentMethod () {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      this.processingPayment = true;
      this.paymentAttemptCompleted = false;
      this.paymentAttemptMessage = null;

      let se = this.$refs.stripeCard.$refs.element;

      instance.createPaymentMethod('card', se._element)
      .then((paymentMethod, error) => {
         if (error) {
           console.error("Stripe Payment Method Error", error);
           this.processingPayment = false;
         } else {
           console.log(paymentMethod);
           this.processPayment(paymentMethod);
         }
       });
    },
    processPayment(paymentMethod) {
      PaymentService.processStripePayment(paymentMethod, this.$store.state.checkout.cart)
      .then(response => {
        this.paymentIntent = response.intent;
        this.confirmCardPayment(response.intent.client_secret, paymentMethod);
      }).catch(error => {
        console.log(error);
        this.processingPayment = false;
      })

    },
    confirmCardPayment(client_secret, paymentMethod) {
      instance.confirmCardPayment(client_secret, {
        payment_method: paymentMethod.id
      }).then(response => {

        if (response.paymentIntent !== undefined) {
          // this.handleSuccess(response.paymentIntent);
          // We have a confirmation response. Send it to the server for processing (order creation, invoice generation etc.)
          this.confirmStripePayment(response.paymentIntent);
        }
        if (response.error !== undefined) {
          this.handleFailure(response.error);
        }

      }).catch(error => {
        console.log(error);
        this.processingPayment = false;
      })
    },
    confirmStripePayment(paymentIntent) {
      console.log('confirmStripePayment()');
      PaymentService.confirmStripePayment(paymentIntent, this.$store.state.checkout.cart)
      .then(response => {
        this.handleSuccess(response.PaymentIntent)
      }).catch(error => {
        console.log('caught error')
        console.log(error);
        if (error.code) {
          this.handleFailure(error)
        } else {
          this.paymentAttemptCompleted = true;
          this.processingPayment = false;
          this.paymentAttemptMessage = 'Der skete en fejl. Prøv igen.';
        }
      })
    },
    handleSuccess(paymentIntent) {
      // console.log('paymentIntent.status');
      // console.log(paymentIntent.status);
      if (paymentIntent.status === 'requires_capture' || paymentIntent.status === 'succeeded' ) {
        this.paymentAttemptCompleted = true;
        this.processingPayment = false;
        this.paymentAccepted = true;
        this.$store.commit('mutateCart', null);
        this.$store.commit('mutatebillingAddress', null);
        this.paymentAttemptMessage = 'Betalingen blev godkendt. Du videredirigeres til ordreresumé';
        // Push to order confirmation page..
        this.$router.push({ path: '/order/confirmation' })
      }
    },
    handleFailure(error) {
      if (error.code === 'payment_intent_authentication_failure') {
        this.paymentAttemptCompleted = true;
        this.processingPayment = false;
        this.paymentAttemptMessage = 'Betaling fejlede. Prøv igen.';
        return;
      }
      if (error.code === 'card_declined') {
        if (error.decline_code === 'insufficient_funds') {
          this.paymentAttemptCompleted = true;
          this.processingPayment = false;
          this.paymentAttemptMessage = 'Betaling fejlede. Ikke tilstrækkelig dækning.';
          return;
        }
      }
    },
    async mountStripeScript() {
      let stripeScript = document.createElement('script')
      stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
      stripeScript.async = true
      document.head.appendChild(stripeScript)
    }
  }
}
</script>

<style>
.stripe-card {
  width: 90%;
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 10px;
}
.stripe-card.complete {
  border-color: green;
}

.credit-card-inputs.complete {
  border: 2px solid green;
}


</style>
